import { all } from 'redux-saga/effects';
import { saga as kpiData } from './kpiData/kpiDataSaga';
import { saga as authorization } from './authData/auothorizationSaga';
import { saga as client } from './clientProjectsData/clientProjectsSaga';

export default function* rootSaga() {
  yield all([kpiData(), authorization(), client()]);
}
